<template>
  <page-wrapper :title="title">
    <appointment-filter-bar
      v-model="filterForm"
      @search="handleSearch"
    ></appointment-filter-bar>
    <appointment-table :data="list"></appointment-table>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import { DateTime } from "luxon";
import { baanRueJaiClient } from "@/dependencies";
import AppointmentTable from "../components/AppointmentTable";
import AppointmentFilterBar from "../components/AppointmentFilterBar";

export default {
  components: {
    PageWrapper,
    AppointmentTable,
    AppointmentFilterBar
  },
  data() {
    const title = "รายการนัดหมาย";
    const list = [];
    const filterForm = {
      dateTimeRange: null,
      createdAtRange: null,
      provider: null,
      project: null,
      service: null,
      home: null,
      status: null
    };

    return {
      title,
      list,
      filterForm
    };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupList();
    },
    setupList() {},

    async handleSearch() {
      const appointments = await this.searchAppointment();

      this.list = appointments.map(appointment => {
        const {
          id,
          date_time: dateTimeRaw,
          status,
          service,
          provider,
          project,
          created_at: createdAtRaw,
          user,
          home
        } = appointment;
        return {
          id: id.toString(),
          dateTime: DateTime.fromISO(dateTimeRaw).toUTC(),
          status,
          service: {
            id: service.id.toString(),
            name: service.name,
            shortDescription: service.short_description
          },
          provider: {
            name: provider.name
          },
          home: {
            address: `บ้านเลขที่ ${home.address_no}`,
            project: project.project_name,
            contact: {
              name: `${user.first_name} ${user.last_name}`,
              phoneNumber: user.mobile_number || "-"
            }
          },
          route: {
            name: "AppointmentDetailPage",
            params: { id }
          },
          createdAt: DateTime.fromISO(createdAtRaw).toUTC()
        };
      });
    },
    async searchAppointment() {
      const params = this.getSearchParams();

      const response = await baanRueJaiClient.admin.subscriptions.appointments.list(
        params
      );

      return response.data.result;
    },
    getSearchParams() {
      const {
        dateTimeRange,
        createdAtRange,
        provider,
        project,
        service,
        home,
        status
      } = this.filterForm;

      const params = {};

      if (dateTimeRange) {
        params.dateTime = {
          from: dateTimeRange.from.toISO(),
          to: dateTimeRange.to.toISO()
        };
      }

      if (home) {
        params.homeId = home.homeId;
      }

      if (createdAtRange) {
        params.createdAt = {
          from: createdAtRange.from.toISO(),
          to: createdAtRange.to.toISO()
        };
      }

      if (project) {
        params.projectId = project.projectId;
      }

      if (provider) {
        params.providerId = provider.id;
      }

      if (service) {
        params.serviceId = service.id;
      }

      if (status) {
        params.status = status;
      }

      return params;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.filter-bar {
  padding: $space;
}
</style>
